export default {
    updateDirectoryTags: function (eventId, directoryId, tags) {
        return {
            type: 'UPDATE_DIRECTORY_TAGS',
            eventId,
            directoryId,
            tags,
        };
    },
};
